import { createEffect, on } from 'solid-js';
import { CapabilityCoordinatorBase, CapabilityRegistry } from '@trimble/web3d';
import { MeasurementsCapabilityProvider } from '@trimble/web3d-providers';
import { isProjectGeometryVisible } from '../../data-state/DataContextProviderHelpers';
import { ProjectDataState } from '../../data-state/DataStateModels';

/**
 * Clears measurements when no project geometry remains visible for 3D rendering.
 */
export class MeasurementsClearingCapabilityCoordinator extends CapabilityCoordinatorBase<CapabilityRegistry> {
  constructor(
    capabilityRegistry: CapabilityRegistry,
    private readonly dataState: ProjectDataState
  ) {
    super(capabilityRegistry);

    createEffect(
      on(
        () => isProjectGeometryVisible(this.dataState),
        (visible, prevVisible) => {
          if (prevVisible === undefined) {
            return;
          }
          if (prevVisible && !visible) {
            this.clearMeasurements();
          }
        }
      )
    );
  }

  private clearMeasurements(): void {
    this.registry
      .get(MeasurementsCapabilityProvider)()
      ?.removeAllMeasurements();
  }

  public cleanup(): Promise<void> {
    return Promise.resolve();
  }
}
